import { useState, useEffect } from 'react';
import axios from 'axios';
import { Card } from '@/components/ui/card';
import { Award } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function TopScorers({ ageGroup }) {
  const [scorers, setScorers] = useState([]);
  const [initialLoading, setInitialLoading] = useState(true);

  useEffect(() => {
    setInitialLoading(true);
  }, [ageGroup]);

  useEffect(() => {
    const fetchScorers = async () => {
      try {
        const { data } = await axios.get(`${API}/players/top-scorers?age_group=${ageGroup}`);
        setScorers(data);
      } catch (error) {
        console.error('Failed to fetch top scorers:', error);
      } finally {
        setInitialLoading(false);
      }
    };

    fetchScorers();
    const interval = setInterval(fetchScorers, 15000);
    return () => clearInterval(interval);
  }, [ageGroup]);

  return (
    <Card className="bg-[#131C2F] border border-white/10 p-6" data-testid="top-scorers-list">
      <h3 className="text-2xl font-bold text-white mb-6">Top Scorers - {ageGroup}</h3>
      {initialLoading ? (
        <p className="text-[#9BA3AF]">Loading top scorers...</p>
      ) : scorers.length === 0 ? (
        <p className="text-[#9BA3AF]">No players registered for this age group yet.</p>
      ) : (
        <div className="space-y-3">
          {scorers.map((player, index) => (
            <div
              key={player.id}
              data-testid={`scorer-${player.id}`}
              className="flex items-center justify-between p-4 rounded-lg bg-[#0A0F1C] border border-white/5 hover:border-[#D4AF37]/30 transition-all"
            >
              <div className="flex items-center gap-4">
                <div
                  className={`w-10 h-10 rounded-full flex items-center justify-center font-bold ${
                    index === 0
                      ? 'bg-[#D4AF37] text-[#0A0F1C]'
                      : index === 1
                      ? 'bg-[#9BA3AF] text-[#0A0F1C]'
                      : index === 2
                      ? 'bg-[#CD7F32] text-white'
                      : 'bg-[#1E2A42] text-white'
                  }`}
                >
                  {index + 1}
                </div>
                <div>
                  <p className="text-white font-semibold">{player.name}</p>
                  <p className="text-[#9BA3AF] text-sm">{player.team_name}</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <Award className="w-5 h-5 text-[#D4AF37]" />
                <span className="text-[#D4AF37] font-bold text-2xl font-mono">{player.goals}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
}
